import { render, staticRenderFns } from "./ProductTagAdd.vue?vue&type=template&id=289f5852&"
import script from "./ProductTagAdd.vue?vue&type=script&lang=js&"
export * from "./ProductTagAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports